import './polyfills';
import { LicenseInfo } from '@mui/x-license';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import './styles/_keyframe-animations.scss';
import './styles/_variables.scss';
import '@fontsource-variable/raleway';
import '@fontsource-variable/karla';
import ReactDOM from 'react-dom/client';
import { jwtDecode } from 'jwt-decode';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import router from './router';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import * as Sentry from '@sentry/react';

import useAppStore from '@/store/app';

const refreshToken = localStorage.getItem('refreshToken');
if (refreshToken && refreshToken.substring(0, 2) === 'ey') {
  const decoded = jwtDecode(refreshToken);
  if (decoded.exp * 1000 < Date.now()) {
    localStorage.removeItem('refreshToken');
    useAppStore.setState({ loggedIn: false });
  } else {
    useAppStore.setState({ loggedIn: true, user: decoded });
  }
} else {
  useAppStore.setState({ loggedIn: false });
}

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import '@fontsource/karla/200.css';
import '@fontsource/karla/300.css';
import '@fontsource/karla/400.css';
import '@fontsource/karla/500.css';
import '@fontsource/karla/600.css';
import '@fontsource/karla/700.css';
import '@fontsource/karla/800.css';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

Sentry.init({
  dsn: 'https://3b9897e17a4334becb1a11f5549c5357@o4510815817039872.ingest.de.sentry.io/4510816213467216',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  environment: import.meta.env.MODE,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <RouterProvider router={router} />
      <ToastContainer
        hideProgressBar
        position="bottom-right"
        closeButton={true}
      />
    </LocalizationProvider>
  </ThemeProvider>,
);
